<template>
  <div class="Store">
    <VendorCreate
        v-if="res"
        :vid="vendor_id"
        :rate="rate_enable"
        :video="video_enable"
        :back="false">
    </VendorCreate>
  </div>
</template>

<script>
  import VendorCreate from "@/components/Vendors/VendorCreate/VendorCreate";
  import {homeInfo} from "@/utils/api";
  export default {
    components:{
      VendorCreate
    },
    props: {},
    data:()=>{
      return {
        res:false,
        vendor_id:'0',
        rate_enable:false,
        video_enable:false,
      }
    },
    beforeMount(){
      homeInfo('overview').then(res => {
        if (res.errcode === 0) {
          this.vendor_id = res.vendor_id?res.vendor_id:'0';
          this.rate_enable = res.user_rate_enable;
          this.video_enable = res.user_video_enable;
          this.res = res;
          // console.log(res)

        } else {
          this.$message.error(res.errmsg);
          this.$router.replace('/login')
        }
      });
    }
  };
</script>

<style scoped>
  .Store{
    padding: 30px 20px;
    box-sizing: border-box;
  }
</style>